module.exports = __webpack_public_path__ + "static/media/service.67717712.svg";